import { createExternalRouteRef } from '@backstage/frontend-plugin-api';

export const rootDocsRouteRef = createExternalRouteRef({
  params: ['namespace', 'kind', 'name'],
});
